import React from 'react';
import {Page, ListGroup, Row, Container, Button} from '../../components';


export default class extends React.Component {


    constructor(props) {
        super(props);
        this.state = {};
    }


    render() {
        return (
            <Page>
                <Container>
                    <Row>
                        <h3>Vad vill du nu då?! 🤔</h3>
                    </Row>

                </Container>
                <ListGroup>
                    <ListGroup.Item  action active={false} href='#/tickers'>Visa tickers</ListGroup.Item>
                    <ListGroup.Item  action active={false} href='#/sandbox-3'>Sandlåda 3 (kan rensa ut gamla tickers)</ListGroup.Item>
                    <ListGroup.Item  action active={false} href='#/sandbox-4'>Sandlåda 4 (visar just nu felloggen)</ListGroup.Item>
                    <ListGroup.Item  action active={false} href='#/sandbox-9'>Sandlåda 9</ListGroup.Item>
                </ListGroup>
            </Page>
        );
    }
}
  

